import { render, staticRenderFns } from "./index.vue?vue&type=template&id=283db666"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283db666')) {
      api.createRecord('283db666', component.options)
    } else {
      api.reload('283db666', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=283db666", function () {
      api.rerender('283db666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalModal/index.vue"
export default component.exports